import { render } from "./CasesInfo.vue?vue&type=template&id=622d8e00&scoped=true"
import script from "./CasesInfo.vue?vue&type=script&lang=js"
export * from "./CasesInfo.vue?vue&type=script&lang=js"

import "./CasesInfo.vue?vue&type=style&index=0&id=622d8e00&scoped=true&lang=css"

import exportComponent from "/home/entheo/wetouch2_bce_2022/site_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622d8e00"]])

export default __exports__